// extracted by mini-css-extract-plugin
export default {"articleClass":"MainStyles_articleClass__M+RId"};